module.exports = __webpack_public_path__ + "static/circuits-01955a5c2bac7a6b68c7fb1d85775b32.jpg";